export default __webpack_public_path__ + "assets/images/70ed946189b555dff0e5098178241e6d.png";